import { apiClientSource } from '../common/axiosInstanceSource';
import { handleAxiosError } from '../common/handleAxiosError';

interface UploadTaskFileResponse {
  success: boolean;
  message: string;
  data: {
    url: string;
    filename: string;
  };
}

export const uploadTaskFile = async (formData: FormData): Promise<UploadTaskFileResponse> => {
  try {
    const response = await apiClientSource.post<UploadTaskFileResponse>(
      '/task-service/api/tasks/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al subir el archivo");
    throw error;
  }
}; 